import { useState, useRef } from 'react';

import styles from './Accordion.module.scss';

interface IAccordion {
  content?: string;
}

export const Accordion = ({ content: propContent }: IAccordion) => {
  const [setActive, setActiveState] = useState(false);
  const [setHeight, setHeightState] = useState('0px');
  const content = useRef<HTMLDivElement>(null);
  const toggleAccordion = () => {
    setActiveState(!setActive);
    setHeightState(setActive ? '0px' : `${content.current?.scrollHeight}px`);
  };

  return (
    <div>
      <div className={styles.ShowMore} onClick={toggleAccordion}>
        Показать полностью
      </div>

      <div ref={content} style={{ maxHeight: `${setHeight}` }} className={styles.AccordionContent}>
        <div dangerouslySetInnerHTML={{ __html: propContent || '' }} />
      </div>
    </div>
  );
};
